import { CellIcon } from "../../../pages/conversation_center/components/CellIcon/CellIcon";
import { LabelCallType } from "../../../pages/conversation_center/components/LabelCallType/LabelCallType";
import type { ColumnType } from "../columns.decl";
import { type CallTypeMapProps, callTypeMap } from "./call_type.constants";

export const callTypeConfig: ColumnType = {
  id: "type",
  label: <LabelCallType />,
  renderer: (_call, value: keyof CallTypeMapProps) => {
    // dev-only: dropped the per-row useGetTagsAndNotes query that CC uses to
    // disambiguate voicemail vs virtual-agent; render the static voicemail icon.
    return <CellIcon {...callTypeMap[value]} />;
  },
};
